import stockCheck from '@js/store/modules/stock-check';
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('stockCheck', ['stockCheck', 'hasFinalized']),

        canUpdate() {
            return this.can(this.permission.SAVE_STOCK_CHECK);
        },

        canEdit() {
            return this.canUpdate && !this.hasFinalized;
        },
    },

    beforeCreate() {
        if (!this.$store.hasModule('stockCheck')) {
            this.$store.registerModule('stockCheck', stockCheck);
        }
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/stock_check/stock-check-mixin.js